/**
 * WeDo Coaching — French translations
 * Source of truth for all visible site copy.
 */
const fr = {
  common: {
    cta: {
      contact: "Démarrer un échange",
      contactShort: "Échanger",
      diagnostic: "Faire le diagnostic",
      bookCall: "Prendre rendez-vous",
      readMore: "Lire l'article",
      requestInfo: "Demander des informations",
      send: "Envoyer le message",
      sending: "Envoi…",
      learnMore: "En savoir plus",
      backToBlog: "Retour au carnet",
    },
    referenced: "Référencés par",
    referencedSub: "Industriel · Recherche · Aéronautique · Énergie · Services",
    quote: "« Les difficultés d'une entreprise ne sont jamais uniquement humaines ou techniques. »",
    confidential: "Vos informations restent confidentielles. Réponse sous 24h ouvrées.",
    loading: "Chargement…",
    emptyBlog: "Aucun article publié pour le moment.",
  },

  nav: {
    expertises: "Nos expertises",
    about: "À propos",
    team: "Équipe",
    references: "Références",
    blog: "Blog",
    diagnostic: "Diagnostic",
    contact: "Contact",
    expertiseList: [
      { label: "Dirigeants & CODIR", desc: "Coaching dirigeant, accompagnement collectif", path: "/dirigeants-codir" },
      { label: "Management & Leadership", desc: "Posture, autonomie, communication, exigence", path: "/management-leadership" },
      { label: "École de Management", desc: "Académies & parcours managériaux durables", path: "/ecole-management" },
      { label: "COO / Conseil opérationnel", desc: "Structuration, croissance, multi-sites", path: "/coo-conseil" },
      { label: "Séminaires & Transformation", desc: "Séminaires CODIR, transformation collective", path: "/seminaires" },
      { label: "PCM & Dynamiques", desc: "Process Communication, leadership relationnel", path: "/pcm" },
    ],
  },

  footer: {
    pitch: "Wedo accompagne le fonctionnement réel des organisations.",
    colAccompaniments: "Accompagnements",
    colExpertises: "Expertises",
    colContact: "Contact",
    legal: "Mentions légales",
    admin: "Espace admin",
    rights: "Tous droits réservés.",
    interventions: "France · Europe · International (FR / EN)",
  },

  home: {
    hero: {
      eyebrow: "Leadership · CODIR · Management · Transformation · Organisation",
      line1: "Mieux décider.",
      line2: "Mieux coopérer.",
      line3a: "Mieux ",
      line3b: "responsabiliser.",
      lede: "Wedo accompagne les dirigeants, managers et organisations à clarifier leur fonctionnement, renforcer leur leadership collectif et structurer des modes de collaboration plus durables. Décisions, gouvernance, management, coordination, responsabilités, transformation collective : nous intervenons là où les enjeux humains, managériaux et organisationnels se rencontrent réellement.",
    },
    pillars: {
      eyebrow: "Notre approche",
      titleA: "Transformer les organisations.",
      titleB: "Renforcer le leadership.",
      lede: "Une approche née du terrain. Douze années en direction des opérations, en CODIR, dans des environnements de croissance, de structuration et de management multi-sites. Wedo accompagne aujourd'hui les organisations sur ce qui conditionne réellement leur fonctionnement : qualité des décisions, clarté des rôles, posture managériale, coopération et capacité à évoluer durablement.",
      items: [
        { label: "Leadership & CODIR", desc: "Aligner les décisions et renforcer le collectif dirigeant." },
        { label: "Management & Leadership", desc: "Développer des managers solides, responsables et structurants." },
        { label: "Conseil & Structuration", desc: "Accompagner la croissance et le fonctionnement opérationnel." },
        { label: "Séminaires & Transformation", desc: "Créer des temps collectifs qui transforment réellement les pratiques." },
      ],
    },
    figures: {
      eyebrow: "L'expérience derrière la marque",
      title: "Une approche éprouvée.",
      items: [
        { num: "12", suffix: "ans", label: "en direction des opérations et en CODIR" },
        { num: "320", suffix: "+", label: "dirigeants et managers accompagnés à ce jour" },
        { num: "4", suffix: "continents", label: "d'intervention en Europe et à l'international" },
      ],
    },
    offers: {
      eyebrow: "Domaines d'intervention",
      titleA: "Travailler les ",
      titleAccent1: "systèmes",
      titleB: " autant que les ",
      titleAccent2: "humains",
      cta: "Tous nos accompagnements",
      items: [
        { tag: "Dirigeants & CODIR", title: "Aligner ceux qui décident", desc: "Coaching dirigeant. Accompagnement collectif du CODIR. Diagnostic du fonctionnement réel et facilitation stratégique." },
        { tag: "COO / Conseil opérationnel", title: "Structurer la croissance", desc: "Structuration, rôles, coordination, multi-sites, passage à l'échelle. Un regard d'opérationnel, pas de théoricien." },
        { tag: "Management & Leadership", title: "Outiller les managers", desc: "Posture, exigence, communication, arbitrages. Des managers qui tiennent leur rôle dans la durée." },
        { tag: "École de Management", title: "Une académie. Pas un catalogue.", desc: "Académies managériales sur-mesure. Culture, repères partagés, transformation durable des pratiques." },
      ],
    },
    william: {
      eyebrow: "À propos",
      titleA: "Avant le coaching,",
      titleB: "l'opérationnel.",
      caption: "William Marques · Fondateur",
      role: "Ex-Directeur des opérations · Coach certifié · PCM",
      p1: "Douze années en direction opérationnelle. Membre de CODIR. Accompagnement d'une entreprise passée de 4 à plus de 70 collaborateurs. Structuration, développement international, coordination multi-sites.",
      p2: "Cette expérience nourrit aujourd'hui une approche concrète, systémique et profondément ancrée dans le réel des organisations.",
      cta: "Le parcours en détail",
    },
    manifesto: {
      eyebrow: "Notre conviction",
      title: "« Les organisations ne ralentissent pas par manque de talent. Elles ralentissent lorsque les rôles, les décisions et les responsabilités deviennent flous. »",
      lede: "Wedo accompagne le fonctionnement réel des organisations, le développement du leadership et la structuration des collectifs dans des environnements complexes.",
      ctaConversation: "Engager la conversation",
    },
  },

  about: {
    eyebrow: "William Marques · Fondateur",
    titleA: "L'opérationnel ",
    titleAccent: "avant",
    titleB: " le coaching.",
    lede: "Avant d'accompagner les organisations, Wedo les a vécues de l'intérieur. Douze ans en direction opérationnelle. CODIR. Croissance. Multi-sites. International. Une approche profondément ancrée dans le réel.",
    keyFacts: [
      { num: "12+", label: "années en direction opérationnelle" },
      { num: "70+", label: "collaborateurs accompagnés en croissance" },
      { num: "2 000+", label: "projets pilotés · clients Top 40 & firmes internationales" },
      { num: "FR · EN", label: "interventions bilingues" },
    ],
    bio: {
      eyebrow: "Parcours",
      title: "Né du ",
      titleAccent: "terrain.",
      p1: "Fondateur de Wedo Coaching, William Marques accompagne aujourd'hui des dirigeants, CODIR, managers et organisations sur des enjeux de leadership, de fonctionnement collectif, de transformation et de structuration managériale.",
      p2: "Avant de se consacrer à l'accompagnement, William a évolué pendant plus de 12 ans dans des fonctions de direction opérationnelle et de développement d'entreprise, au sein d'environnements mêlant croissance, structuration, innovation et management multi-sites.",
      p3: "Diplômé d'un Master en Change Management through Innovation de l'ENSAM, il a notamment occupé des fonctions de Directeur des Opérations et membre CODIR dans une entreprise à la croisée de la construction et de la technologie. Il y accompagne la structuration de l'organisation, le développement de nouveaux produits et solutions techniques, la coordination d'équipes multi-sites ainsi que le développement international.",
      p4: "Au cours de cette expérience, il participe à la croissance de l'entreprise, passant de 4 à plus de 70 collaborateurs, tout en pilotant des enjeux de structuration, de management, de coordination transverse et de transformation opérationnelle.",
      p5: "Cette expérience terrain nourrit aujourd'hui une approche de l'accompagnement plus concrète, plus systémique et profondément connectée au réel des organisations.",
    },
    intersections: {
      eyebrow: "À l'intersection",
      title: "Les difficultés d'une entreprise ne sont jamais uniquement humaines ou techniques.",
      lede: "William intervient à l'intersection de :",
      items: ["Leadership", "Fonctionnement collectif", "Communication", "Décisions", "Rôles & responsabilités", "Structuration organisationnelle"],
    },
    certifications: {
      eyebrow: "Formation & Certifications",
      title: "Un cadre ",
      titleAccent: "rigoureux.",
      items: [
        { label: "Master Change Management through Innovation", org: "ENSAM Arts et Métiers" },
        { label: "Coach professionnel certifié", org: "Institut Maïeutis" },
        { label: "Process Communication Model (PCM)", org: "Kahler Communication France certifié" },
        { label: "12+ années en direction opérationnelle", org: "Directeur des Opérations · Membre CODIR · Multi-sites · International" },
      ],
    },
    testimonials: {
      eyebrow: "Ils en parlent",
      title: "Ce que les clients en disent.",
    },
    cta: {
      eyebrow: "Engager la conversation",
      title: "Un premier échange de 30 minutes pour cadrer votre besoin.",
    },
  },

  team: {
    eyebrow: "L'équipe",
    titleA: "Un collectif d'",
    titleAccent: "expertises.",
    lede: "Wedo n'est plus une personne. C'est aujourd'hui un collectif d'experts certifiés, chacun avec son terrain, son histoire et son angle d'intervention. Ensemble, nous accompagnons dirigeants, CODIR et organisations à transformer leur fonctionnement réel.",
    cta: {
      eyebrow: "Travailler avec Wedo",
      title: "Le bon coach pour le bon enjeu. À chaque mission.",
    },
  },

  blog: {
    eyebrow: "Réflexions",
    title: "Le carnet.",
    lede: "Convictions, retours d'expérience et lectures du terrain sur le leadership, le fonctionnement collectif, la transformation et la structuration des organisations.",
    featured: "À la une",
    notFound: "Article introuvable.",
    allArticles: "Tous les articles",
    furtherEyebrow: "Pour aller plus loin",
    furtherTitle: "Échanger sur votre contexte ?",
    backToBlog: "Retour au blog",
    tocEyebrow: "Sommaire",
    tocTitle: "Tous les articles",
    tocFooter: "Retrouvez ces articles et bien d'autres au fil de l'eau sur LinkedIn.",
  },

  newsletter: {
    title: "Recevoir les nouveaux articles",
    lede: "Une notification courte à chaque nouvelle publication. Pas de spam, pas de bruit.",
    placeholder: "votre@email.pro",
    submit: "S'inscrire",
    sending: "Envoi…",
    success: "Merci ! Vous recevrez les prochains articles dès leur publication.",
    error: "Une erreur est survenue. Réessayez plus tard.",
    privacy: "Vos données restent confidentielles. Désinscription possible à tout moment.",
    subjectEmail: "[Newsletter] Inscription au carnet Wedo",
    messageBody: "Inscription à la newsletter Wedo Coaching depuis la page Blog.",
  },

  resources: {
    eyebrow: "Ressources",
    title: "Outils & guides.",
    lede: "Quelques outils pratiques pour diagnostiquer, structurer et faire évoluer le fonctionnement de votre organisation.",
    empty: "Aucune ressource disponible pour le moment.",
    download: "Télécharger",
  },

  references: {
    eyebrow: "Références",
    titleA: "Ils nous ont fait ",
    titleAccent: "confiance.",
    lede: "Un aperçu anonymisé des missions menées auprès de dirigeants, CODIR et organisations. Chaque accompagnement est calibré sur-mesure ; les exemples ci-dessous donnent une idée de la profondeur et de la diversité des engagements.",
    empty: "Aucune référence publiée pour le moment.",
    ctaEyebrow: "Un projet similaire ?",
    ctaTitle: "Échangeons sur votre contexte et vos enjeux.",
  },

  contact: {
    eyebrow: "Engager un échange",
    title: "Disons-nous les choses.",
    lede: "Un premier échange de 30 minutes pour cadrer votre besoin, comprendre votre contexte et voir s'il y a matière à travailler ensemble. Sans engagement, sans posture commerciale.",
    sections: {
      coordinates: "Coordonnées",
      coordinatesTitle: "Joindre Wedo directement.",
      form: "Formulaire",
      formTitle: "Décrire votre contexte.",
      calendar: "Prendre rendez-vous",
      calendarTitle: "Un créneau direct dans l'agenda.",
      calendarLede: "Choisissez un créneau de 30 minutes pour un premier échange. Visioconférence ou téléphone. Cette première conversation est offerte et sans engagement.",
    },
    labels: {
      email: "Email",
      linkedin: "LinkedIn",
      interventions: "Interventions",
      interventionsValue: "France · Europe · International (FR / EN)",
    },
    form: {
      name: "Nom et prénom *",
      email: "Email *",
      company: "Entreprise",
      phone: "Téléphone",
      subject: "Sujet",
      message: "Votre message *",
      success: "Message envoyé. Nous revenons vers vous sous 24h ouvrées.",
      error: "Une erreur est survenue.",
    },
  },

  services: {
    common: {
      coreBlock: "Au cœur de l'accompagnement",
      coreTitle: "Les sujets que nous travaillons concrètement.",
      formats: "Formats d'intervention",
      formatsTitle: "Comment nous intervenons.",
      ctaEyebrow: "Et concrètement ?",
      ctaTitle: "Un premier échange de 30 minutes pour cadrer le besoin.",
    },
    codir: {
      eyebrow: "Dirigeants & CODIR",
      titleA: "Aligner ceux qui ",
      titleAccent: "décident.",
      lede: "Un CODIR qui fonctionne, c'est : des décisions claires, des rôles assumés et une parole qui circule sans filtre. Le reste suit.",
      sections: [
        {
          title: "Le sommet conditionne tout le reste.",
          body: [
            "Dans la majorité des organisations en croissance, les tensions opérationnelles trouvent leur racine au sommet : une décision floue, un rôle non tenu, un sujet qui ne se traite pas.",
            "Le management répercute. Les équipes encaissent.",
            "Travailler le CODIR, c'est travailler le levier qui conditionne l'ensemble du fonctionnement collectif.",
          ],
        },
        {
          title: "Observer. Clarifier. Structurer.",
          body: [
            "Nous démarrons par un diagnostic du fonctionnement réel : entretiens, observation des instances, lecture des rituels, analyse des décisions, compréhension des tensions structurantes.",
            "Puis nous accompagnons : les rôles, les responsabilités, les modes de décision, les rituels collectifs, et la capacité du CODIR à fonctionner durablement ensemble.",
          ],
        },
      ],
      bullets: [
        "Gouvernance et instances de décision",
        "Alignement et coopération au sommet",
        "Rôles, responsabilités et arbitrages",
        "Cascading des décisions vers le management",
        "Régulation des tensions structurantes",
        "Diagnostic du fonctionnement collectif",
      ],
      formats: [
        { title: "Coaching dirigeant individuel", desc: "Accompagnement régulier du dirigeant ou du membre de CODIR sur sa posture, ses décisions stratégiques et son rôle dans le collectif." },
        { title: "Accompagnement collectif CODIR", desc: "Cycle d'accompagnement sur 6 à 12 mois : observation, séminaires structurants, ateliers de régulation, suivi des engagements." },
        { title: "Diagnostic de fonctionnement", desc: "Diagnostic court (4 à 6 semaines) : entretiens, observation, restitution. Une lecture extérieure et structurée du fonctionnement réel." },
        { title: "Facilitation stratégique", desc: "Animation de séminaires stratégiques et de moments clés du CODIR avec préparation amont et plan d'actions en sortie." },
      ],
    },
    management: {
      eyebrow: "Management & Leadership",
      titleA: "Outiller ceux qui ",
      titleAccent: "portent.",
      lede: "Le management est souvent le maillon qui tient… ou qui rompt. Posture, communication, autonomie, tensions, priorisation : nous aidons les managers à tenir leur rôle dans la durée.",
      sections: [
        {
          title: "Du collaborateur exemplaire au manager.",
          body: [
            "Le passage à un rôle de management ne se décrète pas. Il se construit. Avec des outils, du recul, une posture et un cadre de référence partagé.",
            "Nous accompagnons les managers à passer d'une posture d'expert ou de référent technique à une posture de leader d'équipe : exigeant, structurant, et profondément humain.",
          ],
        },
        {
          title: "Tenir le cadre. Faire grandir.",
          body: [
            "Un bon manager n'est pas celui qui plaît. C'est celui qui aide ses équipes à progresser, qui pose les exigences claires, qui régule les tensions et qui sait responsabiliser sans déléguer son rôle.",
            "Notre approche combine apprentissages structurants, mises en situation, retours d'expérience et accompagnement individuel pour ancrer les transformations.",
          ],
        },
      ],
      bullets: [
        "Posture et autorité managériale",
        "Délégation, responsabilisation, exigence",
        "Communication, feedback, recadrage",
        "Gestion des tensions et arbitrages",
        "Animation d'équipe et rituels managériaux",
        "Conduite des conversations difficiles",
      ],
      formats: [
        { title: "Coaching managérial individuel", desc: "Accompagnement régulier sur 6 à 12 séances pour ancrer une posture managériale alignée et exigeante." },
        { title: "Parcours managérial collectif", desc: "Cycle de modules (présentiel + intersessions) pour une promotion de managers : alignement, langage commun, exigence partagée." },
        { title: "Codéveloppement managérial", desc: "Groupes de pairs animés pour résoudre des situations managériales réelles avec méthode et intelligence collective." },
        { title: "Ateliers ciblés", desc: "Demi-journées ou journées thématiques : feedback, délégation, gestion des conflits, animation d'équipe." },
      ],
    },
    ecole: {
      eyebrow: "École de Management",
      titleA: "Faire ",
      titleAccent: "grandir",
      titleB: " les managers dans la durée.",
      lede: "Une école de management n'est pas une succession de formations. C'est un cadre commun qui permet à une organisation de développer sa propre culture managériale : langage partagé, posture commune, standards de management, modes de fonctionnement et niveau d'exigence collectif.",
      sections: [
        {
          title: "Construire une culture managériale commune.",
          body: [
            "Nous concevons des académies et parcours managériaux sur-mesure permettant d'aligner durablement les pratiques et les comportements managériaux au sein de l'organisation.",
            "L'objectif n'est pas uniquement de former des managers. Il s'agit de créer un référentiel commun, développer des pratiques cohérentes, renforcer l'autonomie, fluidifier la communication et structurer une culture managériale durable dans le quotidien réel de l'entreprise.",
          ],
        },
        {
          title: "Des parcours conçus pour le réel.",
          body: [
            "Nos dispositifs combinent modules structurants, mises en situation, codéveloppement, intersessions, accompagnement individuel et outils de communication et de management.",
            "Chaque parcours est construit sur-mesure selon le niveau de maturité des managers, les enjeux de l'organisation, la culture existante et les transformations à accompagner.",
          ],
        },
      ],
      bullets: [
        "Académies managériales sur-mesure",
        "Cadre commun et culture managériale",
        "Codéveloppement entre pairs",
        "Ancrage dans le quotidien réel",
        "Do.We · compagnon entre les sessions",
        "Suivi individuel optionnel",
      ],
    },
    coo: {
      eyebrow: "COO · Conseil opérationnel",
      titleA: "Structurer la ",
      titleAccent: "croissance.",
      lede: "Quand une entreprise grandit vite, le fonctionnement craque souvent avant l'humain. Rôles flous, coordination chaotique, décisions remontées trop haut, équipes qui s'épuisent : c'est exactement là que nous intervenons.",
      sections: [
        {
          title: "Un regard d'opérationnel.",
          body: [
            "Avant d'accompagner les entreprises, William a piloté la croissance d'une organisation passée de 4 à plus de 70 collaborateurs en tant que Directeur des opérations et membre de CODIR.",
            "Cette expérience terrain nourrit aujourd'hui un conseil opérationnel profondément ancré dans le réel : structuration, management, croissance, coordination, multi-sites, transformation.",
          ],
        },
        {
          title: "Le passage à l'échelle se prépare.",
          body: [
            "Au-delà d'un certain seuil, le système qui a fait votre succès devient celui qui vous freine. Fondateurs goulots. Décisions qui remontent. Management intermédiaire sans cadre pour tenir.",
            "Nous accompagnons la structuration : organisation cible, rôles, rituels managériaux, coordination transverse. La croissance devient une opportunité, pas un risque.",
          ],
        },
        {
          title: "Pour qui ?",
          body: [
            "Dirigeants de PME en croissance. Structures multi-sites. Organisations en transformation. Entreprises qui changent d'échelle. Fondateurs devenus goulots de décision.",
            "DG, COO et dirigeants de transition mandatés pour générer un impact rapide : post-LBO, sortie de crise, succession, restructuration, scale-up. Wedo apporte un sparring d'opérationnel pour cadrer vite et tenir la trajectoire.",
          ],
        },
      ],
      bullets: [
        "Structuration organisationnelle",
        "Rôles, responsabilités et coordination",
        "Passage à l'échelle et multi-sites",
        "Rituels managériaux et chaîne de décision",
        "Sparring stratégique du dirigeant",
        "Management de transition · impact rapide",
      ],
      formats: [
        { title: "Mission de diagnostic", desc: "Diagnostic organisationnel court (4 à 8 semaines). Photographie claire du fonctionnement réel et plan de structuration priorisé." },
        { title: "COO à temps partagé", desc: "Présence opérationnelle régulière (1 à 2 jours/semaine) pour accompagner la structuration et le pilotage dans la durée." },
        { title: "Mission de structuration", desc: "Accompagnement projet (3 à 9 mois) sur une transformation cible : organisation, multi-sites, déploiement international, structuration commerciale, etc." },
        { title: "Sparring DG / management de transition", desc: "Accompagnement régulier d'un DG, COO ou dirigeant de transition mandaté pour générer un impact rapide. Cadrage, décisions structurantes, gestion de crise, communication stratégique." },
      ],
    },
    seminaires: {
      eyebrow: "Séminaires & Transformation",
      titleA: "Des séminaires qui ",
      titleAccent: "structurent.",
      lede: "Un séminaire utile n'est pas une parenthèse. C'est un moment d'accélération du collectif : ce qui se dit, ce qui se clarifie, ce qui s'engage.",
      sections: [
        {
          title: "Travailler ce que le quotidien ne permet pas.",
          body: [
            "Nous concevons des séminaires de transformation, d'alignement stratégique et de structuration des collectifs. Pour les CODIR, comités de direction et équipes qui veulent transformer leur fonctionnement réel, pas seulement leur cohésion.",
          ],
        },
        {
          title: "L'expérientiel au service du fond.",
          body: [
            "Certains formats intègrent des approches expérientielles ou immersives, calibrées au contexte de l'équipe. Le support change. Le sujet reste : la coopération, la qualité du collectif et la transformation durable des pratiques.",
          ],
        },
      ],
      bullets: [
        "Séminaires CODIR & transformation",
        "Alignement stratégique et coopération",
        "Intelligence collective",
        "Animation de moments clés",
        "Préparation amont & plan d'actions",
        "Formats expérientiels discrets et premium",
      ],
    },
    pcm: {
      eyebrow: "PCM · Dynamiques relationnelles",
      titleA: "Comprendre comment ",
      titleAccent: "on fonctionne.",
      lede: "Process Communication Model : une grille de lecture exigeante des dynamiques relationnelles, des besoins psychologiques et des comportements sous stress. Un outil de fonctionnement, pas un test de personnalité.",
      badgeAlt: "Coach Accrédité PCM · Process Communication Model",
      sections: [
        {
          title: "Un outil d'une rare précision.",
          body: [
            "PCM décrit la diversité des façons de communiquer, de coopérer, et de réagir lorsque la pression monte.",
            "Coach accrédité PCM par Kahler Communication France, William intègre PCM de manière transverse à l'ensemble des accompagnements Wedo : dirigeant, CODIR, parcours managériaux, séminaires d'équipe. PCM n'est pas un dispositif isolé : c'est une grille qui irrigue toutes nos interventions.",
          ],
        },
        {
          title: "Adapter sa communication. Sans se trahir.",
          body: [
            "PCM permet de mieux se connaître, d'adapter son fonctionnement aux autres, et de réguler les tensions d'un collectif.",
            "Au-delà de l'individu, PCM transforme la dynamique d'équipe : meilleure régulation des écarts, langage commun, anticipation des comportements sous pression.",
          ],
        },
      ],
      bullets: [
        "Inventaire de personnalité individuel",
        "Décodage des besoins psychologiques",
        "Compréhension du comportement sous stress",
        "Adaptation de sa communication",
        "Leadership relationnel",
        "Cohésion et dynamique d'équipe",
        "Management adapté à chaque profil",
        "Communication client / commerciale",
        "Recrutement et intégration",
      ],
      formats: [
        { title: "PCM équipe", desc: "Atelier d'équipe (1 à 2 jours) pour cartographier la dynamique collective et installer un langage commun." },
        { title: "PCM intégré au coaching", desc: "Intégration de PCM dans un coaching individuel : particulièrement utile pour les dirigeants et managers en prise de poste." },
        { title: "PCM CODIR", desc: "Format dédié pour les comités de direction : cartographie, régulation, leadership collectif." },
        { title: "PCM dans les parcours managériaux", desc: "Brique PCM intégrée aux académies et parcours de l'École de Management Wedo pour ancrer un langage commun." },
      ],
    },
    rise: {
      eyebrow: "RISE · Expérience premium réservée",
      eyebrowDiscreet: "Pour aller plus loin · Sur invitation",
      titleDiscreet: "RISE — l'expérience réservée à un cercle restreint.",
      ledeDiscreet: "Un format immersif rare, conçu pour les dirigeants et CODIR qui souhaitent travailler en profondeur leur posture, leur lucidité stratégique et leur capacité à durer. Hors du quotidien. Hors catalogue.",
      discoverDiscreet: "Découvrir RISE",
      titleA: "Prendre ",
      titleAccent: "de la hauteur.",
      titleB: " Vraiment.",
      lede: "RISE est une expérience immersive conçue pour les dirigeants, entrepreneurs et leaders qui ressentent le besoin de sortir du rythme opérationnel pour retravailler leur vision, leur posture, leur lucidité, leur énergie et leur capacité à durer dans des environnements exigeants. Le support expérientiel crée les conditions du recul. Le vrai sujet reste le leadership.",
      sections: [
        {
          title: "Rare. Exclusif. Transformationnel.",
          body: [
            "RISE n'est pas un séminaire ouvert. Chaque immersion réunit un nombre limité de dirigeants prêts à travailler en profondeur leur fonctionnement réel et leurs enjeux stratégiques.",
            "Format individuel sur-mesure ou cercle restreint de pairs (5 à 8 dirigeants). Lieu, rythme et intensité conçus pour la situation.",
          ],
        },
      ],
      bullets: [
        "Prise de recul stratégique",
        "Vision, posture, énergie",
        "Environnement immersif & exigeant",
        "Format individuel ou collectif (5-8)",
        "Coaching individuel intégré",
        "Plan d'actions à la sortie",
      ],
      formats: [
        { title: "RISE individuel", desc: "Immersion sur-mesure pour un dirigeant. Cadre privatif, rythme et thématiques calibrés. Intensité maximale." },
        { title: "RISE collectif", desc: "Cercle restreint de pairs (5 à 8 dirigeants). Regards croisés, dynamique exigeante, plan d'actions individualisé." },
      ],
    },
  },

  flowProgram: {
    eyebrow: "FLOW · Programme autonome",
    titleA: "90 jours pour ",
    titleAccent: "retrouver son rythme.",
    lede: "FLOW est notre programme autonome de pilotage personnel. 6 modules, 90 jours, construits à partir de plus de 200 séances de coaching de terrain. Pour les dirigeants et managers qui veulent tenir dans la durée : sans s'éteindre, sans sur-adapter.",
    bullets: [
      "Clarté du fonctionnement personnel",
      "Énergie & régulation sous pression",
      "Posture & limites assumées",
      "Plan d'actions concret en sortie",
    ],
    cta: "Découvrir FLOW",
    baseline: "Clarté · Énergie · Posture · Pour la durée.",
    modules: [
      { n: "01", t: "Manuel personnel" },
      { n: "02", t: "Énergie & rythme" },
      { n: "03", t: "Stress & automatismes" },
      { n: "04", t: "Dire les choses clairement" },
      { n: "05", t: "Posture & limites" },
      { n: "06", t: "Tenir dans la durée" },
    ],
    footer: "200+ séances de terrain",
  },

  doWeJourney: {
    badge: "Exemple anonymisé · chaque parcours est conçu sur-mesure",
    eyebrow: "Parcours managers · 9 mois",
    titleA: "Un cadre commun.",
    titleAccent: "Une montée en exigence.",
    lede: "Chaque parcours est calibré pour le client : durée, modules, rythme, thématiques, publics concernés. Voici un exemple représentatif d'une architecture sur 9 mois, pour une promotion de managers.",
    milestones: [
      { when: "Mois 1", label: "Séminaire de lancement", desc: "Cadre commun, contrat de promo, posture de départ." },
      { when: "Mois 2 → 4", label: "Module A · Connaissance de soi", desc: "Comprendre son fonctionnement et son impact dans le rôle managérial." },
      { when: "Mois 4 → 6", label: "Module B · Posture & communication", desc: "Clarté des messages, qualité du feedback, juste distance." },
      { when: "Mois 6 → 8", label: "Module C · Performance collective", desc: "Coopération, délégation, autonomie de l'équipe." },
      { when: "Mois 9", label: "Certification & ancrage", desc: "Bilan tripartite, plan d'actions individuel, coaching option." },
    ],
    footerNote: "Document représentatif",
    footerText: "Co-développement supervisé puis autonome entre les modules. Coaching individuel en option. Bilan tripartite (manager / N+1 / DRH).",
    dowe: {
      badge: "Do.We · Continuité pédagogique · En développement",
      eyebrow: "Un accompagnement qui continue entre les sessions",
      lede: "Les transformations managériales ne se jouent pas uniquement pendant les ateliers ou les séminaires. Do.We prolonge le travail engagé pendant les parcours : prises de recul guidées, soutien à la priorisation, préparation de situations sensibles, ancrage des pratiques, continuité pédagogique, réflexion managériale. L'objectif : renforcer l'autonomie et favoriser une progression durable dans le réel du quotidien managérial.",
      chatTitle: "Do.We · Compagnon Wedo",
      chatStatus: "EN LIGNE",
      userMsg: "Je dois faire un feedback difficile à un membre de mon équipe demain. Comment je m'y prends ?",
      botLabel: "Prise de recul guidée",
      botMsg: "Quelques questions pour préparer cet échange :",
      botList: ["Quel comportement précis souhaitez-vous adresser ?", "Quel impact concret a-t-il sur l'équipe ?", "Quel résultat attendez-vous de la conversation ?"],
      botNote: "Vous pourrez ensuite vous appuyer sur la trame vue avec William en Module B.",
      placeholder: "Écrire un message à Do.We…",
      confidential: "Confidentiel",
      quote: "« Pas pour remplacer l'humain. Pour prolonger le coach entre les sessions. »",
      quoteAuthor: "· Wedo",
    },
  },

  langSwitcher: {
    soonTitle: "EN · Coming soon",
    soonDesc: "La version anglaise arrive prochainement. William intervient déjà en bilingue.",
  },
};

export default fr;
